<template>
    <v-row no-gutters>
        <v-col class="pt-5 pr-2" cols="3">
            <v-select v-model="select" label="항목 선택" :items="selectItems" outlined dense/>
        </v-col>
        <v-spacer />
        <v-col class="pa-2" v-if="select === 'cp'" cols="9">
            <v-row no-gutters>
                <v-col class="pr-5" cols="5"><v-select v-model="selectedCp" :items="cps" item-text="name" :return-object="true" label="cp" /></v-col>
                <v-col cols="auto">
                    <v-btn v-bind="{ loading }" class="mt-3" tile @click="push">추가</v-btn>
                </v-col>
                <v-spacer />
                <v-col cols="auto">
                    <v-btn v-bind="{ loading }" class="mt-3 green--text" tile @click="pushAll">전체 추가</v-btn>
                    <v-btn v-bind="{ loading }" class="mt-3 red--text" tile @click="removeAll">전체 삭제</v-btn>
                </v-col>
            </v-row>
        </v-col>
        <v-col v-if="select === 'price'" cols="9">
            <v-row no-gutters>
                <v-col class="pa-2" cols="3"><v-text-field v-model="price" label="API 가격설정" type="number" /></v-col>
                <v-col class="pa-2" cols="auto">
                    <v-btn class="mt-3" v-bind="{ loading }" tile @click="setPrice">적용</v-btn>
                </v-col>
                <v-spacer />
                <v-col class="pa-2" cols="auto">
                    <v-btn class="mt-3 green--text" v-bind="{ loading }" tile @click="setPriceAll">전체 적용</v-btn>
                </v-col>
            </v-row>
        </v-col>
        <v-col v-if="select === 'isApi'" cols="9">
            <v-row no-gutters>
                <v-col class="pa-2" cols="3">
                    <v-btn v-bind="{ loading }" class="mt-3" tile @click="setIsApi(true)">ON</v-btn>
                    <v-btn v-bind="{ loading }" class="mt-3" tile @click="setIsApi(false)">OFF</v-btn>
                </v-col>
                <v-spacer />
                <v-col class="pa-2" cols="auto">
                    <v-btn v-bind="{ loading }" class="mt-3 green--text" tile @click="setIsApiAll(true)">전체 ON</v-btn>
                    <v-btn v-bind="{ loading }" class="mt-3 red--text" tile @click="setIsApiAll(false)">전체 OFF</v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import api from "@/api";
import { initGiftcardCpPrice } from "./giftcard-cp-price-dialog.vue";
export default {
    props: {
        value: { type: Array, default: () => [] },
        selected: { type: Array, default: () => [] },
    },
    data() {
        return {
            loading: false,
            select: "cp",
            selectItems: [
                { text: "CP", value: "cp" },
                { text: "API 가격", value: "price" },
                { text: "API 사용여부", value: "isApi" },
            ],
            forms: [],
            selectedCp: "",
            price: 0,
            cps: [],
        };
    },
    methods: {
        init() {
            this.search();
            this.sync();
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { cps } = await api.console.cps.gets({});
                this.cps = cps;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        sync() {
            this.forms = this.value;
        },

        // CP 추가 설정
        push() {
            if (!this.selectedCp) return;
            if (this.forms.filter(({ cp }) => cp._id === this.selectedCp._id).length >= 1) return;
            this.forms.push(initGiftcardCpPrice({ cp: this.selectedCp, _cp: this.selectedCp._id }));
            this.emit();
        },
        pushAll() {
            this.cps.forEach((user) => {
                if (this.forms.filter(({ cp }) => cp._id === user._id).length < 1) {
                    this.forms.push(initGiftcardCpPrice({ cp: user, _cp: user._id }));
                }
            });
            this.emit();
        },
        removeAll() {
            this.forms = [];
            this.emit();
        },

        setPrice(price) {
            if (!price || !this.selected.length) return;
            this.updateForms("price", this.price);
        },

        setPriceAll(price) {
            if (!price) return;
            this.updateForms("price", this.price, true);
        },

        setIsApi(isApi = false) {
            if (!this.selected.length) return;
            this.updateForms("isApi", isApi);
        },

        setIsApiAll(isApi = false) {
            this.updateForms("isApi", isApi, true);
        },

        updateForms(property, value, isAll = false) {
            if (isAll) {
                this.forms.forEach((form) => {
                    form[property] = value;
                });
            } else {
                const formsMap = new Map(this.forms.map(({ _cp, cp, price, isApi }) => [cp._id, initGiftcardCpPrice({ _cp, cp, price, isApi })]));

                this.selected.forEach(({ cp }) => {
                    if (formsMap.has(cp._id)) {
                        formsMap.get(cp._id)[property] = value;
                    }
                });

                this.forms = Array.from(formsMap.values());
            }

            this.emit();
        },

        emit() {
            this.$emit("input", this.forms);
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            this.sync();
        },
    },
};
</script>

<style>
</style>